import { Route } from "react-router-dom";

import { LoginPage } from "../pages/LoginPage";
import { UpdateTranslationsPage } from "../pages/UpdateTranslationsPage";
import { EnvironmentsPage } from "../pages/EnvironmentsPage";
import { PullRequestsPage } from "../pages/PullRequestsPage";
import { ComparePage } from "../pages/ComparePage";
import { ChangelogPage } from "../pages/ChangelogPage";
import { HostedToolsPage } from "../pages/HostedToolsPage";

export const RoutePaths = {
  root: "/",
  default: "*",
  translationUpdater: "/translations",
  environmentsCompare: "/environments-compare",
  pullRequests: "/pull-requests",
  login: "/login",
  changelog: "/changelog",
  hostedTools: "/hosted-tools",
};

export const AuthAppRoutes = [
  <Route
    path={RoutePaths.root}
    key={RoutePaths.root}
    element={<EnvironmentsPage />}
  />,
  <Route
    path={RoutePaths.environmentsCompare}
    key={RoutePaths.environmentsCompare}
    element={<ComparePage />}
  />,
  <Route
    path={RoutePaths.translationUpdater}
    key={RoutePaths.translationUpdater}
    element={<UpdateTranslationsPage />}
  />,
  <Route
    path={RoutePaths.pullRequests}
    key={RoutePaths.pullRequests}
    element={<PullRequestsPage />}
  />,
  <Route
    path={RoutePaths.login}
    key={RoutePaths.login}
    element={<LoginPage />}
  />,
  <Route
    path={RoutePaths.changelog}
    key={RoutePaths.changelog}
    element={<ChangelogPage />}
  />,
  <Route
    path={RoutePaths.hostedTools}
    key={RoutePaths.hostedTools}
    element={<HostedToolsPage />}
  />,
  <Route
    path={RoutePaths.default}
    key={RoutePaths.default}
    element={<div>no such page</div>}
  />,
];

export const AppRoutes = [
  <Route
    path={RoutePaths.root}
    key={RoutePaths.root}
    element={<EnvironmentsPage />}
  />,
  <Route
    path={RoutePaths.login}
    key={RoutePaths.login}
    element={<LoginPage />}
  />,
  <Route
    path={RoutePaths.default}
    key={RoutePaths.default}
    element={<div>no such page</div>}
  />,
];
